import { render, staticRenderFns } from "./test.vue?vue&type=template&id=ba9ce782&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=ba9ce782&prod&lang=less"
import style1 from "./test.vue?vue&type=style&index=1&id=ba9ce782&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ce782",
  null
  
)

export default component.exports